import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import QRScanner from '../components/QRScanner';
import SimpleParkingForm from '../components/SimpleParkingForm';

const CheckInPage = () => {
  const { spotId } = useParams();
  const [currentSpotId, setCurrentSpotId] = useState(spotId || null);
  const [showScanner, setShowScanner] = useState(!spotId);

  useEffect(() => {
    if (spotId) {
      setCurrentSpotId(spotId);
      setShowScanner(false);
    }
  }, [spotId]);

  const handleQRScanSuccess = (decodedText) => {
    console.log('QR Code scanned:', decodedText);

    // Extract spot ID from URL
    const urlParts = decodedText.split('/');
    const scannedSpotId = urlParts[urlParts.length - 1];

    setCurrentSpotId(scannedSpotId);
    setShowScanner(false);
  };

  const handleQRScanError = (error) => {
    // Silently handle scanning errors
  };

  // Show QR Scanner if no spot ID
  if (showScanner) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="bg-white shadow">
          <div className="max-w-3xl mx-auto px-4 py-6">
            <h1 className="text-2xl font-bold text-gray-900 text-center">Scan QR Code</h1>
            <p className="text-gray-600 text-center mt-2">Point your camera at the parking spot QR code</p>
          </div>
        </div>

        <div className="max-w-3xl mx-auto px-4 py-8">
          <div className="bg-white rounded-lg shadow p-6">
            <QRScanner
              onScanSuccess={handleQRScanSuccess}
              onScanError={handleQRScanError}
            />
          </div>

          <div className="mt-6 text-center">
            <p className="text-gray-600 mb-4">Or skip scanning and enter manually:</p>
            <button
              onClick={() => setShowScanner(false)}
              className="inline-block px-6 py-3 bg-gray-600 text-white rounded-lg font-semibold hover:bg-gray-700"
            >
              Enter Without QR Code
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Show simple form once spot ID is known (or user chose to skip)
  return <SimpleParkingForm spotId={currentSpotId} />;
};

export default CheckInPage;
